import { render } from "./BaseNotification.vue?vue&type=template&id=632a1ba5&scoped=true"
import script from "./BaseNotification.vue?vue&type=script&lang=js"
export * from "./BaseNotification.vue?vue&type=script&lang=js"

import "./BaseNotification.vue?vue&type=style&index=0&id=632a1ba5&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-632a1ba5"]])

export default __exports__